import { ProgramPage as Page } from '@sandtech-hub-monorepo/ui-kit-site';
import { AppRoutesPaths } from '../../routes/types';

/**
 * The degree program detail, rendered at /program/:programId for a degree
 * learner.
 *
 * `universityOnly` sends a GSA abbreviation to the not-found page rather than
 * rendering it here. Without it the shared page resolves either product type,
 * so a degree learner could open a GSA program in the degree shell - and that
 * page carries an enrol control.
 */
export const DegreeProgram = () => (
  <Page
    learningPageLink={AppRoutesPaths.Learning}
    programsPageLink={AppRoutesPaths.Programs}
    notFoundPageLink={AppRoutesPaths.NotFound}
    universityOnly
  />
);
